module.exports = __webpack_public_path__ + "static/assets/09c942201c597f8e8122cb72693b7352.svg";